<dacks-content>
  <div class="p-4 md:p-6 lg:w-[var(--mixed-content-card-container-width)] lg:mx-auto">
<!-- TODO sobald dacks-content-header auch mehrzeilig sein kann, die h1 damit umsetzen -->
    <h1 class="text-petrol-650 mu-heading-3 md:mu-heading-2 md:pl-4 pb-4 md:pb-2">
      @if ((groupedProductChanges$ | async); ) {
        <span>{{ 'product-change.title' | translate }} {{ productTitle }}</span>
      }
    </h1>

    <div class="md:pl-4">

      <div class="flex justify-end mb-4 md:mb-6 md:max-w-[73.5rem]">
        <a mat-button class="w-fit min-w-10 gap-2" color="light"
           aria-label="Zur Startseite von DATEV MyUpdates"
           href="{{environment.entryPoint}}" target="_blank">
          <mat-icon svgIcon="fi-link-extern-20"
                    class="!w-5 !h-5 !min-w-5 !min-h-5 !flex-shrink-0"
                    aria-hidden="true"></mat-icon>
          <span class="whitespace-nowrap">
            Zur Startseite von DATEV MyUpdates
          </span>
        </a>
      </div>

      @if ((groupedProductChanges$ | async); as groupedProductChanges) {
        <div class="grid grid-cols-1 gap-4 md:max-w-[73.5rem] pt-2 md:pt-6">
          @if ((groupedProductChanges?.length ?? -1) > 0) {
            <div class="space-y-4 md:space-y-6">
              <!-- Filter-Bereich mit responsivem Spacing -->
              <div class="w-fit">
                <dackl-filter-single-select
                  [label]="'product-change-selection.sort_prefix' | translate"
                  [selections]="sortOrderSelections"
                  [(selectedValue)]="sortOrderSelection"
                  (selectedValueChange)="sortOrderChanged()">
                </dackl-filter-single-select>
              </div>

              <!-- Legal Notice mit responsiver Textgröße -->
              <div class="text-sm lg:text-base text-gray-600">
                {{ 'delivery.legal_notice' | translate }}
              </div>

              <!-- Prüfe ob Gruppierung notwendig ist (mehr als ein ProductKey) -->
              @if (groupedProductChanges.length > 1) {
                <!-- Accordion für gruppierte Anzeige -->
                <div class="pt-4">
                  <dackl-accordion displayMode="light">
                    @for (group of groupedProductChanges; track group.productTitle) {
                      <dackl-expansion-panel
                        [headline]="group.productTitle"
                        [id]="'panel-' + group.productTitle"
                        [expanded]="isPanelExpanded('panel-' + group.productTitle)"
                        (opened)="onPanelOpened('panel-' + group.productTitle)"
                        (closed)="onPanelClosed('panel-' + group.productTitle)">

                        <!-- Responsive Card Grid innerhalb des Panels -->
                        <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2
                                    gap-4 md:gap-6 lg:max-w-[73.5rem] mt-2 mb-3">
                          @for (productChange of group.productChanges; track productChange; let pcnr = $index) {
                            <div class="w-full">
                              <myupdates-product-change-card
                                [productChange]="productChange"
                                [pcnr]="pcnr"
                                [dateTranslation]="dateTranslation"
                                [dateTranslationMonth]="dateTranslationMonth"
                                [openInNewTab]="true">
                              </myupdates-product-change-card>
                            </div>
                          }
                        </div>
                      </dackl-expansion-panel>
                    }
                  </dackl-accordion>
                </div>
              } @else {
                <!-- Normale Anzeige ohne Accordion wenn nur ein ProductKey vorhanden -->
                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2
                            gap-4 md:gap-6 lg:max-w-[73.5rem]">
                  @for (productChange of groupedProductChanges[0].productChanges; track productChange; let pcnr = $index) {
                    <div class="w-full">
                      <myupdates-product-change-card
                        [productChange]="productChange"
                        [pcnr]="pcnr"
                        [dateTranslation]="dateTranslation"
                        [dateTranslationMonth]="dateTranslationMonth"
                        [openInNewTab]="true">
                      </myupdates-product-change-card>
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            <!-- Responsive Empty State -->
            <div class="flex justify-center items-center min-h-[200px] md:min-h-[300px] px-4">
              <dackl-empty-state
                [title]="'product-change-selection.empty_product_change_list' | translate"
                class="w-full max-w-md">
                <p class="text-center font-semibold">
                  {{ 'product-change-selection.empty_product_change_list' | translate }}
                </p>
              </dackl-empty-state>
            </div>
          }
        </div>
      } @else {
        <!-- Loading/Error States mit responsivem Spacing -->
        <div class="mt-6 md:mt-10">
          @if (errorInfo$ | async) {
            <myupdates-error-box
              class="error-box-white-style"
              [errorTitle]="'product-change-selection.error_selection_title' | translate"
              [errorText]="'product-change-selection.error_selection_text' | translate">
            </myupdates-error-box>
          } @else {
            <div class="flex justify-center py-8 md:py-12">
              <mat-spinner class="text-petrol-500"></mat-spinner>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <footer-spacing type="content" />
</dacks-content>
